import { useEffect, useRef, useState } from "react";
import { SlotMachineNumber } from "./RollingDigit";

interface StatPillProps {
  icon: string;
  value: number;
  suffix: string;
  label: string;
}

const StatPill = ({
  icon,
  value,
  suffix,
  label
}: StatPillProps) => {
  const [animate, setAnimate] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (hasAnimated || !elementRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setAnimate(true);
            setHasAnimated(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(elementRef.current);

    return () => observer.disconnect();
  }, [hasAnimated]);

  // Format value: e.g. 3.5 → "3.5", 13 → "13"
  const decimals = value % 1 !== 0 ? 1 : 0;
  const displayValue = decimals > 0 ? value.toFixed(1) : String(Math.floor(value));

  return (
    <div ref={elementRef} className="stat-pill">
      <span className="stat-pill-label text-sm text-white">{label}</span>
      <div className="stat-pill-content">
        <img src={icon} alt={label} className="stat-pill-icon w-10 h-10" />
        <span className="stat-pill-value">
          <SlotMachineNumber
            value={displayValue}
            animate={animate}
            duration={1800}
            stagger={150}
          />
          <span
            className="stat-pill-suffix"
            style={{
              opacity: animate ? 1 : 0,
              transition: "opacity 0.5s ease 0.3s",
            }}
          >
            {suffix}
          </span>
        </span>
      </div>
    </div>
  );
};

export default StatPill;
